import React from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as Exclamation } from '../../icon/exclamation.svg'
import { Modal, Button } from "react-bootstrap"
import BobbingIcon from '../common/BobbingIcon'
import "../../css/BobbingIcon.css"
import "../../css/SMPLButton.css"

interface SizeRejectionModalProps {
  show: boolean
  minWidth: number
  minHeight: number
  onHide: () => void
}

export default function SizeRejectionModal({ show, minWidth, minHeight, onHide }: SizeRejectionModalProps) {
  const { t } = useTranslation()

  return (
    <Modal show={show} centered onHide={onHide}>
      <Modal.Body className="p-4">
      <BobbingIcon horizontalOffset="-23px" verticalOffset="-20px">
          <Exclamation />
      </BobbingIcon>

        <h1>{t("sizeRejection.heading")}</h1>
        <p>{t("sizeRejection.text", { width: minWidth, height: minHeight })}</p>

      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={onHide}>{t("sizeRejection.buttonTitle")}</Button>
      </Modal.Footer>
    </Modal>
  )
}
